import apibase from './BaseAPI';

const search = async (params) => {
    try {
        const res = await apibase.post('/auditTrails/search', params)
        return res.data

    } catch (err) {
        throw err
    }
}

const save = async (params) => {
    try {
        const res = await apibase.post('/auditTrails/save', params)
        return res.data

    } catch (err) {
        throw err
    }
}

const getUserRoleList = async () => {
    try {
        const res = await apibase.post('/auditTrails/getUserRoleList')
        return res.data

    } catch (err) {
        throw err
    }
}

export default {
    search: search,
    save: save,
    getUserRoleList: getUserRoleList
}